/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export type TSupportedCountries = 'in';

export interface IPremiumCalculatorMessage {
  country: TSupportedCountries;
  coverage: number;
}

interface ICharge {
  raw: number;
  formatted: any;
}

export class PremiumCalculatorMessage {
  public country: string;
  public coverage: number;
  public insuranceProviderCharge?: ICharge;
  public platformCharge?: ICharge;
  public riskCapitalPremium?: any;
  public totalPremium?: any;
  constructor({ country, coverage }: IPremiumCalculatorMessage) {
    this.country = country;
    this.coverage = coverage;
  }
}
